import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "lemburKepegawaian";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const lemburList = "Kepegawaian/LaporanKehadiran/list/";
export const ketidakhadiranPerUnitList =
  "Kepegawaian/LaporanKehadiran/list_ketidakhadiranPerUnit/";
export const lemburExport = "Kepegawaian/LaporanKehadiran/export/";
export const tidakhadirperunitExport =
  "Kepegawaian/LaporanKehadiran/ketidakhadiran_perunit/";
export const akumulasiperunitExport =
  "Kepegawaian/LaporanKehadiran/akumulasi_perunit/";
export const izinperunitExport = "Kepegawaian/LaporanKehadiran/izin_perunit/";
export const izinperunitExport2 = "Kepegawaian/LaporanKehadiran/izin_perunit2/";
export const izinSTperunitExport = "Kepegawaian/LaporanKehadiran/izin_st/";
export const kehadiranPerorangExport =
  "Kepegawaian/LaporanKehadiran/kehadiran_perorang/";
export const kehadiranPerunitExport =
  "Kepegawaian/LaporanKehadiran/kehadiran_perunit/";
export const tidakhadirperunitExportAlpha =
  "Kepegawaian/LaporanKehadiran/tidakhadirperunitExportAlpha/";
export const absensiPerunitExport =
  "Kepegawaian/LaporanKehadiran/absensi_perunit/";
export const absensiPerunitRealTimeExport =
  "Kepegawaian/LaporanKehadiran/absensi_perunit_realtime/";
export const absensiPerorangExport =
  "Kepegawaian/LaporanKehadiran/absensi_perorang/";
export const kehadiranPerunitExportLibur =
  "Kepegawaian/LaporanKehadiran/kehadiran_perunit_libur/";

export const masterWorkUnit = "Master/WorkUnit/list/";
export const masterEmployeeCategories = "Master/List/employeeCategories/";
export const Employee = "Kepegawaian/LaporanKehadiran/get_employee/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
